// Generic leaderboard table primitive. Columns are declarative; cells can
// render arbitrary content (sparklines, links, etc.).
import type { ReactNode } from 'react';

export interface LeaderboardColumn<T> {
  key: string;
  label: string;
  align?: 'left' | 'right' | 'center';
  width?: string;
  render: (row: T, index: number) => ReactNode;
}

interface Props<T> {
  rows: T[];
  columns: LeaderboardColumn<T>[];
  rowKey: (row: T, index: number) => string;
  caption?: ReactNode;
}

export default function Leaderboard<T>({ rows, columns, rowKey, caption }: Props<T>) {
  if (!rows || rows.length === 0) {
    return <div className="trends-chart-empty">No rows in this range.</div>;
  }
  return (
    <table className="trends-leaderboard">
      {caption ? <caption className="trends-leaderboard-caption">{caption}</caption> : null}
      <thead>
        <tr>
          {columns.map((c) => (
            <th key={c.key} style={{ textAlign: c.align ?? 'left', width: c.width }}>
              {c.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={rowKey(row, i)}>
            {columns.map((c) => (
              <td key={c.key} style={{ textAlign: c.align ?? 'left' }}>
                {c.render(row, i)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
